import { Project } from "../../types/project";
export function ProjectVisual({
  project,
  eager = false,
}: {
  project: Project;
  eager?: boolean;
}) {
  return (
    <div className={`project-visual ${project.theme}`}>
      {project.image ? (
        <div className="browser-frame">
          <div className="browser-bar" aria-hidden="true">
            <i />
            <i />
            <i />
            <span>
              {project.live ? new URL(project.live).hostname : project.name}
            </span>
          </div>
          <img
            src={project.image}
            alt={`${project.name} public website`}
            width="1350"
            height="926"
            loading={eager ? "eager" : "lazy"}
            decoding="async"
          />
        </div>
      ) : (
        <div className="commerce-art">
          <span className="eyebrow">CARTIER CREATIVE / CONTRACT</span>
          <p>
            driwego<span>↗</span>
          </p>
          <div className="commerce-lines">
            <span>
              B2C storefronts <b>01</b>
            </span>
            <span>
              B2B commerce <b>02</b>
            </span>
            <span>
              Vendor tools <b>03</b>
            </span>
          </div>
          <span className="commerce-caption">
            NEXT.JS · TYPESCRIPT · MEDUSA.JS
          </span>
        </div>
      )}
    </div>
  );
}
